export default __webpack_public_path__ + "static/media/find_vehicle.f73d60cc.svg";